import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Voicemails from './../components/Voicemails';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    voicemails: state.voicemails,
    business: state.business,
    auth:state.auth,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Voicemails);
